import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import { Typography, message } from 'antd';
import CommonModal from '../../../../../common/CommonModal';
import MessagePreview from '../MessagePreview';
import GeneratorInput from '../../GeneratorInput/GeneratorInput';
import InfoBlock from './InfoBlock';
import { ReactComponent as GreenPlus } from '../../../../../../../assets/icons/plus/greenPlus.svg';
import { withStore } from '../../../../../../../store/rootStore';
import UploadButton from '../../../../../common/UploadButton';
import { DeleteOutlined, ExclamationCircleOutlined, FileOutlined, UploadOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { getDirection } from '../../../../../../../helpers';
import { TEMPLATE_HEADER_TYPE, WhatsApp } from '@whatsper/texterchat-common';
import { RICH_TEMPLATE_BUTTON_TYPE } from '../../../../../../../constants';
import { checkTemplateHeaderFileSize } from '../../../../../../TemplateMessages/helpers';
import { TEMPLATE_HEADER_ACCEPTED_TYPES } from '../../../../../../TemplateMessages/helpers';
import styles from './MessagePreviewModal.module.scss';
import richStyles from '../RichParams/RichParams.module.scss';
const { Text } = Typography;
const MessagePreviewModal = ({ visible, setModalVisible, disabled, store }) => {
    const { bodyExampleTemporaryParams, changeTempExampleParam, setTemplateExamples, nextPlaceholderNumber, richTemplateHeaderType, richTemplateHeader, richTemplateHeaderUrl, hasDocumentSample, richTemplateDocumentFilename, clearRichTemplateHeaderFile, richTemplateFooter, bodyExampleParams, handleSetHeader, quickReplyButtons, callToActionButtons, templateMessage, allTemplateParams, changeConsolidatedParam, } = store.templateMessagesStore;
    const [imagePreviewSrc, setImagePreviewSrc] = useState('');
    const [imagePreviewName, setImagePreviewName] = useState('');
    const [hadInitialFile, setHadInitialFile] = useState(false);
    const [documentSampleRemoved, setDocumentSampleRemoved] = useState(false);
    const [error, setError] = useState('');
    const isImage = richTemplateHeaderType === TEMPLATE_HEADER_TYPE.IMAGE;
    const hasVisibleDocumentSample = hasDocumentSample && !documentSampleRemoved;
    const validateFileSize = (file) => {
        const sizeError = checkTemplateHeaderFileSize(file);
        if (sizeError) {
            message.error(React.createElement(Trans, { i18nKey: sizeError.key, values: { size: sizeError.size } }));
            return false;
        }
        return true;
    };
    const onFileOrImageLoad = (files) => {
        if (files instanceof Error) {
            setError(files.message);
        }
        else {
            handleSetHeader(files);
            setDocumentSampleRemoved(false);
            setError('');
            if (richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType)) {
                setImagePreviewSrc(URL.createObjectURL(files[0]));
            }
        }
    };
    const onCancel = () => {
        setImagePreviewSrc('');
        setImagePreviewName('');
        setDocumentSampleRemoved(false);
        if (!hadInitialFile) {
            handleSetHeader('');
        }
    };
    useEffect(() => {
        if (visible) {
            if (richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType)) {
                if (typeof richTemplateHeader !== 'string' && richTemplateHeader !== null) {
                    if (richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType)) {
                        const src = URL.createObjectURL(richTemplateHeader);
                        setImagePreviewSrc(src);
                    }
                    setImagePreviewName(richTemplateHeader.name);
                }
            }
            else {
                setImagePreviewSrc('');
                setImagePreviewName('');
            }
        }
    }, [visible]);
    useEffect(() => {
        if (visible) {
            if (richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType) &&
                typeof richTemplateHeader !== 'string' &&
                richTemplateHeader !== null) {
                setHadInitialFile(true);
            }
        }
    }, [visible]);
    return (React.createElement(CommonModal, { visible: visible, headerIcon: GreenPlus, titleTextKey: 'addSampleData', modalActionText: 'setData', setModalVisible: setModalVisible, modalAction: () => {
            setTemplateExamples(bodyExampleTemporaryParams);
            if (documentSampleRemoved) {
                clearRichTemplateHeaderFile();
            }
            setModalVisible();
        }, onCancel: onCancel, centerContent: false, destroyOnClose: true },
        React.createElement("div", { className: classNames(styles.modalContent, {
                [styles.rtl]: getDirection() === 'rtl',
            }) },
            React.createElement("div", { className: styles.inputWrapper },
                React.createElement(InfoBlock, null),
                richTemplateHeaderType && [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType) && (React.createElement("div", { className: styles.uploadButtonContainer },
                    React.createElement(UploadButton, { onFileSelected: onFileOrImageLoad, text: imagePreviewName || (isImage ? 'uploadSampleImage' : 'uploadSampleVideo'), types: isImage ? TEMPLATE_HEADER_ACCEPTED_TYPES.image : TEMPLATE_HEADER_ACCEPTED_TYPES.video, additionalStyles: styles.uploadButton, icon: React.createElement(UploadOutlined, null), disabled: disabled, validateFile: validateFileSize, fluid: true }),
                    React.createElement("div", { className: styles.buttonHelpText },
                        React.createElement(ExclamationCircleOutlined, { className: styles.infoCircle }),
                        React.createElement("p", { className: styles.infoText },
                            React.createElement(Trans, { i18nKey: isImage ? "recommendedImageSize" : "recommendedVideoSize" }))))),
                richTemplateHeaderType === TEMPLATE_HEADER_TYPE.DOCUMENT && (React.createElement("div", { className: styles.uploadButtonContainer },
                    hasVisibleDocumentSample && (React.createElement("div", { className: richStyles.documentSample },
                        React.createElement(FileOutlined, null),
                        React.createElement(Text, { className: richStyles.documentSampleName, title: imagePreviewName || richTemplateDocumentFilename || 'File' }, imagePreviewName || richTemplateDocumentFilename || React.createElement(Trans, { i18nKey: "file" })),
                        !disabled && (React.createElement("button", { type: "button", className: richStyles.removeDocumentSample, "aria-label": "Delete", title: "Delete", onClick: () => setDocumentSampleRemoved(true) },
                            React.createElement(DeleteOutlined, null))))),
                    React.createElement(UploadButton, { onFileSelected: onFileOrImageLoad, text: hasVisibleDocumentSample ? 'replaceSampleFile' : 'uploadSampleFile', types: TEMPLATE_HEADER_ACCEPTED_TYPES.document, additionalStyles: styles.uploadButton, icon: React.createElement(UploadOutlined, null), disabled: disabled, fluid: true }),
                    React.createElement("div", { className: styles.buttonHelpText },
                        React.createElement(ExclamationCircleOutlined, { className: styles.infoCircle }),
                        React.createElement("p", { className: styles.infoText },
                            React.createElement(Trans, { i18nKey: "recommendedFileSize" }))))),
                allTemplateParams && allTemplateParams.length > 0 &&
                    allTemplateParams.map((param) => {
                        const labelKey = param.type === 'url' ? 'enterUrlExample' : 'enterParamExample';
                        const placeholderParams = param.type === 'url' ? undefined : { number: param.placeholderNum };
                        let buttonUrl = '';
                        let exampleUrl = '';
                        if (param.type === 'url' && callToActionButtons) {
                            const button = callToActionButtons[param.index];
                            if (button && button.url) {
                                buttonUrl = button.url;
                                // Replacing placeholder with example value to show how to use it
                                exampleUrl = button.url.replace(/{{.*?}}/g, 'custom-param');
                            }
                        }
                        return (React.createElement("div", { key: `${param.type}-${param.index}` },
                            React.createElement(GeneratorInput, { text: param.value, onChange: (value) => changeConsolidatedParam({
                                    type: param.type,
                                    index: param.index,
                                    placeholderNum: param.placeholderNum
                                }, value), placeholder: labelKey, placeholderParams: placeholderParams, additionalStyles: styles.input, disabled: disabled, emojiPicker: param.type !== 'url', options: {
                                    maxLength: 1024,
                                    showCount: true,
                                } }),
                            param.type === 'url' && (React.createElement(Text, { className: styles.urlExampleHelp },
                                React.createElement(Trans, { i18nKey: "urlExampleHelp", values: { url: buttonUrl, example: exampleUrl } })))));
                    })),
            React.createElement("div", { className: styles.previewWrapper },
                React.createElement(MessagePreview, { header: {
                        type: richTemplateHeaderType,
                        text: richTemplateHeader,
                        file: richTemplateHeader,
                        url: documentSampleRemoved ? '' : richTemplateHeaderUrl,
                        previewUrl: imagePreviewSrc,
                    }, body: {
                        text: templateMessage,
                        params: bodyExampleTemporaryParams || bodyExampleParams,
                    }, footer: {
                        type: WhatsApp.TemplateComponentType.FOOTER,
                        text: richTemplateFooter || '',
                    }, buttons: quickReplyButtons
                        ? {
                            buttons: quickReplyButtons,
                            type: RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY,
                        }
                        : callToActionButtons
                            ? {
                                buttons: callToActionButtons,
                                type: RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION,
                            }
                            : undefined })))));
};
export default withStore(observer(MessagePreviewModal));
